<template>
  <div v-show="isShown" class="comp-modal-ok">
    <div class="main-wrapper center-content">
      <div v-show="!isMinMode" class="modal-wrapper animated fadeInUp">
        <v-toolbar>
          <v-toolbar-title  tabindex="1"
            v-focus="initFocus"
            @focus="initFocus = true"
            @blur="initFocus = false">
            {{message}}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn tabindex="4" icon
            v-focus="(moreFocus && !isMinMode)"
            v-show="allowMinMode"
            @focus="moreFocus = true"
            @blur="moreFocus = false"
            @click="switchMode">
            <v-icon>expand_more</v-icon>
          </v-btn>
        </v-toolbar>

        <div class="body">
          <div tabindex="2" class="label">
            {{details}}
          </div>
          <v-btn tabindex="3" @click="clikcedOk">{{buttonLabel}}</v-btn>
        </div>
      </div>

      <div v-show="isMinMode" class="tool-wrapper animated slideInUp">
        <v-toolbar>
          <v-btn tabindex="1" icon
            v-focus="(lessFocus && isMinMode)"
            @focus="lessFocus = true"
            @blur="lessFocus = false"
            @click="switchMode">
            <v-icon>expand_less</v-icon>
          </v-btn>
          <v-toolbar-title  tabindex="2">
            {{message}}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn tabindex="3"
            @click="clikcedOk">
            {{buttonLabel}}
          </v-btn>
        </v-toolbar>
      </div>
    </div>
  </div>
</template>

<script>
import { focus } from 'vue-focus'

export default {
  name: 'ModalOk',
  directives: { focus: focus },
  data () {
    return {
      isMinMode: false,
      initFocus: false,
      moreFocus: false,
      lessFocus: false,
      enableTab: true,
      activeTabIndex: -1,
      hasAnswer: false,
      isCorrect: false
    }
  },
  props: {
    message: {
      type: String,
      default: 'Great! Your answer is correct'
    },
    details: {
      type: String,
      default: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam'
    },
    buttonLabel: {
      type: String,
      default: 'Next'
    },
    isShown: {
      type: Boolean,
      required: false,
      dafault: false
    },
    allowMinMode: {
      dafault: true,
      type: Boolean,
      required: false
    }
  },
  watch: {
    isShown () {
      if (this.isShown) {
        this.initFocus = true
      }
    }
  },
  methods: {
    show () {
      this.isShown = true
    },
    hide () {
      this.isShown = false
    },
    clikcedOk () {
      this.$emit('onClicked', this.isShown)
    },
    switchMode () {
      this.isMinMode = !this.isMinMode
      if (this.isMinMode) {
        this.lessFocus = true
      } else {
        this.moreFocus = true
      }
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style src="./style.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/modal-ok/modalOk.vue